import { menuIcon, navMenu } from '../helpers/helpers';

menuIcon.addEventListener('click', () => {
  menuIcon.classList.toggle('tesla-mobile__hamburger--open');
  navMenu.classList.toggle('tesla-header__nav--open');
});
